/**
 * 拓扑插件-自定义模式
 */
export default {
  default: 'default',
  joinLine: 'joinLine'
};
